export default {
     abc(val){
        alert(val)
  }
}



// WEBPACK FOOTER //
// ./src/service/aaa.js